export default {
  home: {
    matchups: {
      today: "Heutige Matchups",
      thisWeek: "Matchups dieser Woche",
      upcoming: "Kommende Matchups",
    },
    actions: {
      showMore: "Mehr anzeigen",
      showLess: "Weniger anzeigen",
    },
    empty: {
      parlayMinGames: "Noch keine Trends verfügbar. Mindestens 3 Spiele erforderlich.",
    },
    hundredPercentClub: {
      subtitle: "Props, die in 100% der Spiele getroffen haben",
    },
    advancedTools: {
      subtitles: {
        startingLineups: "Finde Value, wenn sich Startaufstellungen ändern. Enthalten mit",
        injuryImpact: "Sieh, wie Verletzungen Teamkollegen beeinflussen. Enthalten mit",
        opponentRank: "Nutze günstige defensive Matchups aus. Enthalten mit",
        startingPitchers: "Ziele auf Spots gegen anfällige Pitcher. Enthalten mit",
        weatherReport: "Nutze Wind und Wetter zu deinem Vorteil. Enthalten mit",
      },
    },
    predictionMarkets: {
      status: {
        loading: "Märkte werden geladen...",
        loadError: "Märkte konnten nicht geladen werden.",
      },
    },
    sidebar: {
      improveExperience: "Verbessere dein Linemate-Erlebnis",
      getAccess: "ERHALTE ZUGANG ZU ERWEITERTEN PLAYS UND TIEFEREN EINBLICKEN",
    },
  },
};
